import React, { useEffect, useState } from "react";
import GoogleMapReact from 'google-map-react';
import { useTranslation } from "react-i18next";


const OFFICE_ADDRESS = "5/15 Field St, Adelaide SA 5000, Australia";

const GoogleMapStyle = ({
  containerClassName = "google-map",
  mapClassName = "map",
}) => {
  const { i18n } = useTranslation();
  const [mapsrc, setMapSrc] = useState("");

  useEffect(() => {
    const lang = {
      "en": "en",
      "zh": "zh-CN"
    }
    setMapSrc(`https://www.google.com/maps?q=${encodeURIComponent(OFFICE_ADDRESS)}&hl=${lang[i18n.language] || "en"}&output=embed`)
  }, [i18n.language])
  const mapStyle = {
    position: "relative",
    display: "block",
    top: "1px",
    zoom: 3.75,
    width: '100%',
    paddingTop: 20,
    paddingRight: 3,
    paddingLeft: 3,
  };

  return (
    <div className={containerClassName}>
      <section style={mapStyle} className={mapClassName}>
        <iframe src={mapsrc} allowFullScreen style={{ width: "100%", borderRadius: 2 }}></iframe>
      </section>
    </div>
  );
};

export default GoogleMapStyle;













